/** 人工检测接口编码，Web/App 与后端保持一致。 */
export const STAGE = Object.freeze({ SAMPLE: 'SAMPLE', ARRIVAL: 'ARRIVAL', COMPLETE: 'COMPLETE' })
export const FLOW_STATUS = Object.freeze({ WAIT_ARRIVAL: 'WAIT_ARRIVAL', WAIT_TEST: 'WAIT_TEST', COMPLETED: 'COMPLETED' })
export const SAMPLING_POINT = Object.freeze({ INLET: 'INLET', OUTLET: 'OUTLET', DEFAULT: 'DEFAULT' })
export const CHECK_TYPE = Object.freeze({ SELF: '0', THIRD_PARTY: '1' })
export const FLOW_VERSION = Object.freeze({ LEGACY: 1, THREE_STAGE: 2 })
export const SYSTEM_TYPE = Object.freeze({ SEWAGE: '52', WATER_POLLUTION: '32' })

/** 使用与后端 SYS_TYPE 一致的系统编码确定是否选择进出水采样点。 */
export function hasSamplingPoints(st) {
  return [SYSTEM_TYPE.SEWAGE, SYSTEM_TYPE.WATER_POLLUTION].includes(String(st))
}
/** st32 进水只保存台账，历史默认点继续沿用原同步口径。 */
export function syncsMonitoring(st, point) {
  return String(st) !== SYSTEM_TYPE.WATER_POLLUTION || point !== SAMPLING_POINT.INLET
}
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const ATTACHMENT_SOURCE = Object.freeze({ SAMPLING: 'manual_check_sampling', ARRIVAL: 'manual_check_arrival', TESTING: 'manual_check' })

export const STAGE_OPTIONS = Object.freeze([
  { value: STAGE.SAMPLE, label: '采样' },
  { value: STAGE.ARRIVAL, label: '到样' },
  { value: STAGE.COMPLETE, label: '检测' }
])
export const FLOW_OPTIONS = Object.freeze([
  { value: FLOW_STATUS.WAIT_ARRIVAL, label: '待到样', tone: 'arrival' },
  { value: FLOW_STATUS.WAIT_TEST, label: '待检测', tone: 'testing' },
  { value: FLOW_STATUS.COMPLETED, label: '已完成', tone: 'completed' }
])
export const INLET_OUTLET_POINTS = Object.freeze([
  { value: SAMPLING_POINT.INLET, label: '进水口' },
  { value: SAMPLING_POINT.OUTLET, label: '出水口' }
])
export const POINT_OPTIONS = Object.freeze(INLET_OUTLET_POINTS.concat({ value: SAMPLING_POINT.DEFAULT, label: '默认采样点' }))
export const CHECK_TYPE_OPTIONS = Object.freeze([
  { value: CHECK_TYPE.SELF, label: '自测' },
  { value: CHECK_TYPE.THIRD_PARTY, label: '第三方实验室' }
])

/** 将选项属性映射到编码键，列表与表单使用同一份名称。 */
function optionMap(options, field) {
  return Object.freeze(options.reduce((result, option) => { result[option.value] = option[field]; return result }, {}))
}
export const FLOW_LABELS = optionMap(FLOW_OPTIONS, 'label')
export const POINT_LABELS = optionMap(POINT_OPTIONS, 'label')
export const CHECK_TYPE_LABELS = optionMap(CHECK_TYPE_OPTIONS, 'label')
export const FLOW_TONES = optionMap(FLOW_OPTIONS, 'tone')
export const SUBMIT_LABELS = Object.freeze({ [STAGE.SAMPLE]: '保存采样', [STAGE.ARRIVAL]: '保存到样', [STAGE.COMPLETE]: '提交完整记录' })
export const QUALIFICATION_LABELS = Object.freeze({ 0: '未填写', 1: '合格', 2: '不合格', 3: '不合格', 4: '数值无效' })
export const STAGE_PATHS = Object.freeze({ [STAGE.SAMPLE]: 'sampling', [STAGE.ARRIVAL]: 'arrival', [STAGE.COMPLETE]: 'testing' })

const STAGE_FIELDS = Object.freeze({
  [STAGE.SAMPLE]: ['siteId', 'samplingPoint', 'samplingDate', 'samplingUser', 'remark'],
  [STAGE.ARRIVAL]: ['arrivalDate', 'arrivalUser', 'arrivalRemark'],
  [STAGE.COMPLETE]: ['checkDate', 'checkType', 'checkUser', 'companyId', 'testingRemark']
})

/** 返回阶段字段白名单，避免接力提交覆盖其他阶段或系统字段。 */
export function getStageFields(stage, complete) {
  return complete ? [].concat(STAGE_FIELDS[STAGE.SAMPLE], STAGE_FIELDS[STAGE.ARRIVAL], STAGE_FIELDS[STAGE.COMPLETE]) : STAGE_FIELDS[stage]
}

/** 判断是否填写，检测值 0 仍然有效。 */
export function hasValue(value) {
  return value !== null && value !== undefined && value !== ''
}

/** 组装服务端 cp 参数，跳过空值并保留零值。 */
export function buildCp(factors) {
  const cp = {}
  factors.forEach(row => { if (hasValue(row.value)) cp[row.code] = String(row.value) })
  return cp
}
